import { Button, Icon, Modal, Text } from '@shopify/polaris';
import { QuestionMarkInverseMinor } from '@shopify/polaris-icons';
import React, { useCallback, useState } from 'react';

interface Props {
  status: 'Pending' | 'Verified' | 'Transferring' | 'Paid-In Transit' | 'Paid'
}

export function ModalExplanationNote(props: Props) {
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive(!active), [active]);

  const activator = (
    <Button onClick={toggleActive} size="micro" icon={<Icon source={QuestionMarkInverseMinor as any} tone="base" />}>
      Help
    </Button>
  )

  const dummy = [
    {
      title: 'Pending',
      description: 'The disbursement request is awaiting verification. This may take one or two working days.'
    },
    {
      title: 'Verified',
      description: 'The disbursement request has been verified and now is awaiting the transferring process.'
    },
    {
      title: 'Transferring',
      description: 'The disbursement is being processed. This may take one or two working days. This is the last step of the disbursement process for which the platform is responsible.'
    },
    {
      title: 'Paid-In Transit',
      description: 'The disbursement is completed. This stage is only available for sellers based outside of Cambodia for their own internal control. The disbursement has been transferred to your valid Cambodia-based bank account or the valid Cambodia-based bank account of your representative or agent.​ The platform is not responsible for any disbursement from this point onwards.. Contact your representative regarding any disbursement in this stage if you have one. Note that the platform can only transfer the disbursement to a compatible Cambodia-based bank account. If you don’t have one, you must work with your private representative or select an available agent. If you select an agent, you agree to allow the agent to receive the disbursement on your behalf and must agree to the agent’s terms and conditions. You must work with the agent to resolve any issue. Again, the platform is not responsible for any of your loss from this point onward. Click on the amount of a specific disbursement or the disbursement ID to upload the proof of your internal transfer.'
    },
    { title: 'Paid', description: 'The disbursement is completed.' }
  ]

  const status = dummy.find(f => f.title === props.status);

  return (
    <Modal title={status?.title} activator={activator} open={active} onClose={toggleActive}>
      <Modal.Section>
        <Text as='p' variant='bodySm'>
          {status?.description}
        </Text>
      </Modal.Section>
    </Modal>
  )
}